<div class="bip-summary">
  <div class="bip-section" *ngFor="let section of sections; let isLast = last">
    <div class="section-header">
      <div class="section-header-content">
        <span class="step-badge"
          >{{ section.stepNumber }}/{{ totalSteps }}</span
        >
        <h3 class="section-title">{{ section.title }}</h3>
        <button
          *ngIf="
            allowManageBehavior &&
            (section.stepNumber !== 1 ||
              (section.stepNumber === 1 && this.behaviorDetail?.draft))
          "
          type="button"
          class="icon-button no-external-text"
          [title]="pageTitles[section.stepNumber - 1].tooltip"
          [attr.aria-label]="
            'Navigate to ' + pageTitles[section.stepNumber - 1].title
          "
          (click)="managePreview(section.stepNumber)">
          <svg-icon
            src="/assets/icon/icon-edit.svg"
            class="icon s-18 redirect no-external-text"
            aria-label="Edit"></svg-icon>
        </button>
      </div>
    </div>

    <div class="section-divider"></div>
    <div class="section-content">
      <div
        class="content-items"
        *ngIf="section.content.items && section.content.items.length">
        <p class="item-text" *ngFor="let item of section.content.items">
          {{ item }}
        </p>
      </div>
      <div
        class="badge-list"
        *ngIf="section.content.badges && section.content.badges.length">
        <span
          class="success-badge"
          *ngFor="let badge of section.content.badges">
          {{ badge }}
        </span>
      </div>
      <div class="description-group" *ngIf="section.content.description">
        <label
          class="field-label"
          for="operational-definition-{{ section.stepNumber }}"
          >Operational Definition</label
        >
        <div class="field-content">
          <p
            class="field-text"
            id="operational-definition-{{ section.stepNumber }}">
            {{ section.content.description }}
          </p>
        </div>
      </div>
      <div
        class="fields-wrapper"
        *ngIf="section.content.fields && section.content.fields.length">
        <div
          class="field-group"
          *ngFor="let field of section.content.fields; let i = index">
          <label
            class="field-label"
            [attr.for]="'field-value-' + section.stepNumber + '-' + i"
            >{{ field.label }}</label
          >
          <div class="field-content">
            <p
              class="field-text"
              [id]="'field-value-' + section.stepNumber + '-' + i">
              {{ field.value }}
            </p>
          </div>
        </div>
      </div>

      <div
        class="checkbox-list"
        *ngIf="
          section.content.checkboxes && section.content.checkboxes.length;
          else noCheckboxes
        ">
        <div
          class="checkbox-item"
          *ngFor="let checkbox of section.content.checkboxes">
          <svg-icon
            src="/assets/icon/icon-checkbox-preview.svg"
            class="checkbox-icon"
            aria-label="Checkbox Preview"></svg-icon>
          <span class="checkbox-label">{{ checkbox.label }}</span>
        </div>
      </div>
      <ng-template #noCheckboxes>
        <span
          *ngIf="
            section.content.checkboxes &&
            (!section.content.otherDescription ||
              !section.content.otherDescription.length)
          ">
          Nothing entered
        </span>
      </ng-template>
    </div>
    <div
      *ngIf="section.content.questions && section.content.questions.length"
      class="questions-section">
      <div
        class="question-group"
        *ngFor="let question of section.content.questions">
        <div class="question-label">{{ question.label }}</div>
        <div class="question-answer">{{ question.value }}</div>
      </div>
    </div>

    <div
      class="other-description"
      *ngIf="
        section.content.otherDescription &&
        section.content.otherDescription.length
      ">
      <div class="section-divider"></div>
      <div class="description-group">
        <label
          class="field-label"
          for="other-description-{{ section.stepNumber }}"
          >Other form of {{ behvaiorCategory }}</label
        >
        <div class="field-content">
          <p
            class="field-text"
            id="other-description-{{ section.stepNumber }}"
            *ngFor="let desc of section.content.otherDescription">
            {{ desc }}
          </p>
        </div>
      </div>
    </div>

    <div class="section-separator" *ngIf="!isLast"></div>
  </div>
</div>
